export const progressbarConfig = {
  color: '#242425',
  height: 4,
  nonce: '',
  options: { easing: 'ease', speed: 500, showSpinner: false },
  showOnShallow: false,
  startPosition: 0.3,
  stopDelayMs: 200
};
